/**
 * UUID generation utility with fallback for environments without crypto.randomUUID()
 */

/**
 * Generate a UUID v4
 * Uses crypto.randomUUID() when available, falls back to manual implementation
 */
export function generateId(): string {
  // Debug logging to track UUID generation
  console.log('🔧 generateId() called');
  
  // Use crypto.randomUUID() if available (modern browsers, secure contexts)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    try {
      const id = crypto.randomUUID();
      console.log('✅ Using crypto.randomUUID():', id);
      return id;
    } catch (error) {
      // Fallback if crypto.randomUUID() fails
      console.warn('❌ crypto.randomUUID() failed, using fallback:', error);
    }
  }

  // Fallback implementation for older browsers or non-secure contexts
  const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
  
  console.log('🔄 Using fallback UUID generation:', id);
  return id;
}